import { ChevronDownIcon } from '@heroicons/react/outline';
import { ListBox } from '@components/base';
import React from 'react';
import cs from 'classnames';

export function SimpleDropdown({
    id,
    label,
    size,
    placeholder,
    value,
    onChange,
    getValue = (val) => val,
    children,
    disabled = false,
    hasError,
    className,
    IconComponent = <ChevronDownIcon className="w-5 h-5 stroke-current text-gray-500" />,
}: {
    id: string;
    label: string;
    size?: 'large' | 'small' | 'xsmall';
    placeholder: string;
    value: string;
    onChange: (val: string) => void;
    getValue?: (val: any) => any;
    children: React.ReactNode;
    IconComponent?: React.ReactNode;
    disabled?: boolean;
    className?: string;
    hasError?: boolean;
}) {
    const containerClass = cs('w-full mb-1 group:focus-within');
    const classNames = cs(`${className} w-full relative whitespace-nowrap`);
    const validValue = value ?? false;
    return (
        <div className={containerClass}>
            <ListBox value={value} onChange={onChange} disabled={disabled}>
                {({ open }: { open: boolean }) => (
                    <React.Fragment>
                        <ListBox.Label className="text-gray-700 text-sm font-medium">
                            {label}
                        </ListBox.Label>
                        <ListBox.Body>
                            <ListBox.Button hasError={hasError} className={classNames} size={size}>
                                {validValue ? (
                                    <div className="text-passport text-sm overflow-hidden truncate after:content-['\200b']">
                                        {getValue(value)}
                                    </div>
                                ) : (
                                    <div
                                        className={`text-gray-500 min-h-full ${
                                            placeholder ? '' : 'py-3'
                                        }`}>
                                        {placeholder}
                                    </div>
                                )}
                                <div className="absolute right-2 top-0 bottom-0 flex items-center justify-center">
                                    {IconComponent}
                                </div>
                            </ListBox.Button>
                            <ListBox.Options open={open}>{children}</ListBox.Options>
                        </ListBox.Body>
                    </React.Fragment>
                )}
            </ListBox>
        </div>
    );
}
